// src/components/common/PasswordStrengthMeter.jsx
import React from 'react';
import { cx } from './ui';

// Mirrors backend/src/utils/passwordValidator.js — four requirements, one
// quarter of the bar each.
const RULES = [
  (p) => p.length >= 8,
  (p) => /[A-Z]/.test(p),
  (p) => /[a-z]/.test(p),
  (p) => /[!@#$%^&*(),.?":{}|<>]/.test(p),
];

const LEVELS = [
  { label: '', bar: 'bg-line-strong', text: 'text-ink-3' },
  { label: 'Weak', bar: 'bg-danger', text: 'text-danger' },
  { label: 'Fair', bar: 'bg-gold', text: 'text-gold' },
  { label: 'Good', bar: 'bg-accent', text: 'text-accent' },
  { label: 'Strong', bar: 'bg-ok', text: 'text-ok' },
];

const PasswordStrengthMeter = ({ password = '' }) => {
  const met = password ? RULES.filter((rule) => rule(password)).length : 0;
  const { label, bar, text } = LEVELS[met];

  return (
    <div className="mt-1.5">
      <div className="flex gap-1" aria-hidden="true">
        {[0, 1, 2, 3].map((i) => (
          <span
            key={i}
            className={cx(
              'h-1 flex-1 rounded-full transition-colors',
              i < met ? bar : 'bg-surface-3'
            )}
          />
        ))}
      </div>
      {label && (
        <p className={cx('mt-1.5 text-xs', text)}>
          Password strength: <span className="font-medium">{label}</span>
        </p>
      )}
    </div>
  );
};

export default PasswordStrengthMeter;
